var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownloadFolder = function SvgDownloadFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3h9.028l2.5 3H22.9v15.4H1V3Zm1.4 1.4V20h19.1V7.4h-9.628l-2.5-3H2.4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.254 15.702 1.663-1.565.783.738-3 2.825-3-2.825.784-.738 1.662 1.565V10.7h1.108v5.002Z",
    fill: "currentColor"
  })));
};
export { SvgDownloadFolder as ReactComponent };
export default __webpack_public_path__ + "874722cfff9d6feebe2cfa1d7f718057.svg";